import type { InfluencerFilters } from './types';

export const INITIAL_INFLUENCER_FILTERS: InfluencerFilters = {
  platform: 'all',
  followers: 'all',
  engagement: 'all',
  location: 'all',
  tier: 'all',
  collaborations: 'all',
  tags: [],
  status: 'all',
  gender: 'all',
};

export const getTierColor = (tier: string): string => {
  switch (tier) {
    case 'Nano':
      return 'bg-green-100 text-green-800';
    case 'Micro':
      return 'bg-blue-100 text-blue-800';
    case 'Macro':
      return 'bg-purple-100 text-purple-800';
    case 'Mega':
      return 'bg-red-100 text-red-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};
